module.exports = __webpack_public_path__ + "img/case_11.3a95b979.png";